import { applyMiddleware, createStore, Store } from 'redux';
import { persistReducer } from 'redux-persist'
import { logger } from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';
import { isNull } from 'lodash-es';
import storage from 'redux-persist/lib/storage'
import rootEpic from '../epics';
import rootReducer, { RootState } from '../reducers';


// const epicMiddleware = createEpicMiddleware();
// const { NODE_ENV = 'development' } = process.env;

// export default function configureStore() {
// 	const middlewares: Array<any> = [epicMiddleware];
// 	if (NODE_ENV === `development`) {
// 		middlewares.push(logger);
// 	}
// 	const store = createStore(rootReducer, applyMiddleware(...middlewares));

// 	epicMiddleware.run(rootEpic as any);
// 	const persistor = persistStore(store)
// 	return { store, persistor };
// }
// export function storeWithoutPersist() {
// 	const middlewares: Array<any> = [epicMiddleware];
// 	const store = createStore(rootReducer, applyMiddleware(...middlewares));
// 	epicMiddleware.run(rootEpic as any);
// 	return { store };
// }


/**
 * Configure store.
 * @returns {object} store - Reducer global store.
 */
export class ApplicationStore {
	static _store: Store<RootState>;

	static get store() {
		if (isNull(this._store)) {
			throw Error('store is not initialized');
		}
		return this._store;
	}

	static init() {
		const epicMiddleware = createEpicMiddleware();
		const { NODE_ENV = 'development' } = process.env;
		const middlewares: Array<any> = [epicMiddleware];
		if (NODE_ENV === `development`) {
			middlewares.push(logger);
		}
		const persistConfig = {
			key: 'root',
			storage,
		}
		const persistedReducer = persistReducer(persistConfig, rootReducer)
		this._store = createStore(persistedReducer, applyMiddleware(...middlewares));

		epicMiddleware.run(rootEpic as any);
	}
}

export const store = ApplicationStore;
